<template>
  <div>
    <!-- 内容区 -->
    <div class="dialiyDuty layout" v-if="!showRatioModel">
      <amap
        ref="myMap"
        :ratioSites="ratioSites"
        :userLevel="userLevel"
        :showRatioEdit="showRatioEdit"
        :fullPileNum="fullPileNum"
        :tableData="tableData"
        :tableDataBrands="tableDataBrands"
        @clearMapTimer="clearMapTimer"
        :mapData="map"
        @onInfoWindowClick="onShowBike"
        :selfAddress="selfAddress"
        :selfAreaId="selfAreaId"
        :currMap="currMap"
      />
      <div class="station-search">
        <station-search
          ref="stationSearch"
          :showRatioEdit="showRatioEdit"
          :selfAreaId="selfAreaId"
          @search="onSearch"
        />
      </div>
      <div class="bike-company" v-if="illegalBikes && illegalBikes.length">
        <el-select
          @change="companyOfIllegalBikeChange"
          v-model="companyOfIllegalBikeValue"
        >
          <el-option key="全部" label="全部" value=""></el-option>
          <el-option
            v-for="item in companyOfIllegalBikes"
            :key="item.name"
            :label="`${item.name}(${item.num})`"
            :value="item.name"
          >
          </el-option>
        </el-select>
      </div>
      <div
        v-show="!showRatioEdit"
        class="message-wall"
        :class="{ w50p: showStatisticsArea && !showMessageArea }"
      >
        <statistics-area
          @dashboardBike="getDashboardBike"
          :tableLoading="tableLoading"
          :aggregation="aggregation"
          @showModel="onShowDialog"
          :statistical="statistical"
          :show="showStatisticsArea"
        />
        <message-area
          :tableLoading="tableLoading"
          :aggregation="aggregation"
          :siteMessage="siteMessage"
          @showModel="onShowDialog"
          :show="showMessageArea"
        />
      </div>

      <template v-if="showRatioEdit">
        <!-- 满桩值编辑 内容区 -->
        <ratio-edit
          @showWindowPop="showWindowPop"
          @onShowDialog="onShowDialog"
          ref="ratioEdit"
          :selfAreaId="selfAreaId"
          @searchMapFromRatio="searchMapFromRatio"
          :ratioEditData="ratioEditData"
        ></ratio-edit>
        <!-- 满桩值编辑 按钮区 -->
        <div class="ratio-btns">
          <el-button size="mini" @click="onRatioEditCancel">取消</el-button>
          <el-button size="mini" @click="onRatioEdit" type="primary"
            >确定</el-button
          >
        </div>
      </template>
    </div>
    <!-- 满桩值设置列表 -->
    <div class="dialiyDuty layout" style="background: #f0f2f5" v-else>
      <ratio
        @changeShow="changeShow"
        @showRatioEdit="changeShowRatioEdit"
      ></ratio>
    </div>

    <!-- 一级弹窗 -->
    <w-dialog
      ref="w-dialog"
      :title="dialogTitle"
      width="60%"
      :isShowFooter="false"
      @handleClose="handleClose"
      @handleCloseRight="handleClose"
      @onSure="onSure"
    >
      <template v-slot:content>
        <component
          v-bind:is="currentComponent"
          :fullPileNum="fullPileNum"
          :detail="detail"
          :siteMessage="siteMessage"
          :companyData="companyData"
          :historyData="historyData"
          :typeName="typeName"
          :currentData="detailSimple"
          @onShowDialog2="onShowDialog2"
          @jjSearch="jjSearch"
        />
      </template>
    </w-dialog>
    <!-- 二级弹窗 w-dialog2 详情 -->
    <w-dialog
      ref="w-dialog2"
      :title="dialogTitle2"
      width="60%"
      :isShowFooter="false"
      @handleCloseRight="handleClose2"
      @handleClose="handleClose2"
    >
      <template v-slot:content>
        <div
          class="dialog-content dialiyDuty-dialog-content"
          v-if="subType === 'bikesEcharts'"
        >
          <div class="bikesEcharts-header">
            站点名称：<span class="mr40">{{
              siteInfoData && siteInfoData.siteName
            }}</span>
            车位数量：<span>{{
              siteInfoData && siteInfoData.siteBikeCeiling
            }}</span>
          </div>
          <div class="text-right" style="padding: 16px 0">
            <el-select
              @change="companySelectChange"
              v-model="companySelect"
              size="small"
              placeholder="请选择"
            >
              <el-option :key="99" label="全部" :value="99"></el-option>
              <el-option
                v-for="item in companyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-date-picker
              style="margin-left: 8px"
              size="small"
              v-model="bikesEchartsData"
              @change="handleBikesEcharts"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </div>
          <!-- echarts -->
          <div id="echarts"></div>
        </div>
        <div class="dialog-content" v-if="subType === 'bikes'">
          <!-- 车辆类型：
            <el-select :disabled="siteInfoData && !!siteInfoData.brandId" v-model="bikeType" @change="bikeTypeChange" size="small" clearable placeholder="车辆类型" style="margin-right:30px;margin-bottom:30px;">
              <el-option
                v-for="item in bikeTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            选择企业：
            <el-select :disabled="siteInfoData && !!siteInfoData.brandId" v-model="brand" @change="brandChange" size="small" clearable placeholder="选择企业" style="margin-bottom:30px;">
              <el-option
                v-for="item in brandBikeList"
                :key="item.brandId"
                :label="item.brandName"
                :value="item.brandId">
              </el-option>
            </el-select> -->
          <w-table
            v-if="tableData2 && tableData2.length"
            v-loading.body="tableLoading2"
            :data-list="tableData2"
            :columns="staticData2[subType].columns"
            :pageNo="formData2.pageNum"
            :pageSize="formData2.pageSize"
            :total="total2"
            :bPagination="needPagination2"
            @pageNoChange="pageNoChange2"
            @pageSizeChange="pageSizeChange2"
          >
            <template slot-scope="props" slot="cell">
              <span v-if="props.column.label === '序号'">{{
                props.index + 1 + (formData2.pageNum - 1) * formData2.pageSize
              }}</span>
              <span v-else-if="props.column.label === '品牌'">{{
                siteInfoData.brandId
                  ? siteInfoData.brandName
                  : props.row[props.column.property]
              }}</span>
              <span
                :class="{ 'sp-red': props.row[props.column.property] === 1 }"
                v-else-if="props.column.label === '合法性'"
                >{{
                  props.row[props.column.property] === 0
                    ? "合法"
                    : props.row[props.column.property] === 1
                    ? "非法"
                    : ""
                }}</span
              >
              <span v-else>{{ props.row[props.column.property] }}</span>
            </template>
          </w-table>
          <div v-else>暂无信息</div>
        </div>
        <div class="dialog-content" v-else>
          <el-button
            v-if="
              ['brandOperationNum', 'brandBikeNum', 'brandEBikeNum'].includes[
                subType
              ]
            "
            type="default"
            style="small"
            @click="onExport"
            >导出数据</el-button
          >
          <w-table
            v-if="tableData2 && tableData2.length"
            v-loading.body="tableLoading2"
            :data-list="tableData2"
            :columns="staticData2[subType].columns"
            :pageNo="formData2.pageNum"
            :pageSize="formData2.pageSize"
            :total="total2"
            :bPagination="needPagination2"
            @pageNoChange="pageNoChange2"
            @pageSizeChange="pageSizeChange2"
          >
            <template slot-scope="props" slot="cell">
              <span v-if="props.column.label === '序号'">{{
                props.index + 1 + (formData2.pageNum - 1) * formData2.pageSize
              }}</span>
              <span v-else-if="props.column.label === '工作单位'">
                <span v-if="companyData && companyData.length">{{
                  companyData.find(
                    (it) => Number(it.brandId) === Number(props.row.brandId)
                  )
                    ? companyData.find(
                        (it) => Number(it.brandId) === Number(props.row.brandId)
                      ).brandName
                    : ""
                }}</span>
              </span>
              <span v-else>{{ props.row[props.column.property] }}</span>
            </template>
          </w-table>
        </div>
      </template>
    </w-dialog>
    <!-- 满桩值设置 -->
    <el-dialog title="温馨提示" :visible.sync="ratioErrorModelShow">
      <template v-if="ratioErrorRes && ratioErrorRes.length">
        <p class="ratio-error-text">当前勾选的站点执行时间与以下任务有冲突！</p>
        <el-table :data="ratioErrorRes">
          <el-table-column
            property="alias"
            label="任务名称"
            width="200"
          ></el-table-column>
          <el-table-column property="week" label="执行时间"></el-table-column>
        </el-table>
      </template>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import Amap from "@/components/Map/index.vue";
import StationSearch from "@/components/DailyDuty/stationSearch.vue";
import StatisticsArea from "@/components/DailyDuty/statisticsArea.vue";
import MessageArea from "@/components/DailyDuty/messageArea.vue";
import TextList from "@/components/Listbox/textList.vue";
import TableList from "@/components/Listbox/tableList.vue";
import HistoryList from "@/components/Listbox/historyList.vue";
import MessageList from "@/components/Listbox/messageList.vue";
import WDialog from "@/components/Model/index.vue";
import TextListSlot from "@/components/Listbox/textListSlot.vue";
import WTable from "@/components/Table/index.vue";
import Ratio from "./ratio";
import RatioEdit from "./ratio-edit";

import staticData2 from "@/views/CompanyManagement/staticData.js";
import staticData from "./staticData.js";
import Api from "@/api";
import { mapGetters } from "vuex";
import store from "@/store";
import { downloadExcel, getUrlParam } from "@/utils/tools.js";
import echarts from "echarts";

export default {
  name: "dialiyDuty",
  components: {
    Amap,
    StationSearch,
    StatisticsArea,
    MessageArea,
    WDialog,
    TextList,
    TableList,
    HistoryList,
    MessageList,
    TextListSlot,
    WTable,
    Ratio,
    RatioEdit,
  },
  data() {
    return {
      typeName: "",
      detail: {},
      detailSimple: {},
      formData: {
        pageNum: 10,
        pageSize: 10,
      },
      total: 660,
      tableLoading: false,
      tableData: null,
      statistical: {},
      map: [],
      siteMessage: [],

      dialogTitle: "",
      currentComponent: "",
      currMap: [],
      timer: null,
      mapTimer: null,
      companyData: null, // 品牌信息列表

      // 二级弹窗
      formData2: {
        pageNum: 1,
        pageSize: 10,
      },
      total2: 1,
      tableLoading2: false,
      tableData2: null,
      subType: "",
      paramsType: "",
      dialogTitle2: "",
      dialogWidth2: "60%",
      sureBtnText2: "确定",
      isShowFooter2: false,
      needPagination2: false,
      historyData: [],
      siteInfoData: null, // 消息区 - 查看 - 参数
      companySelect: "",
      companyOptions: [],
      companyRentOptions: [],
      bikesEchartsData: new Date(),
      siteReturnStatisticsData: null,
      siteRentStatisticsData: null,
      beforeUnload_time: null,
      gap_time: null,
      bikeTypeList: [
        {
          label: "自行车",
          value: 0,
        },
        {
          label: "电动车",
          value: 1,
        },
      ],
      brandBikeList: [],
      bikeType: "",
      brand: "",
      brandId: "",
      hourAndPower: {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 0,
        9: 0,
        10: 0,
        11: 0,
        12: 0,
        13: 0,
        14: 0,
        15: 0,
        16: 0,
        17: 0,
        18: 0,
        19: 0,
        20: 0,
        21: 0,
        22: 0,
        23: 0,
        24: 0,
      },
      hourAndPowerRent: {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 0,
        9: 0,
        10: 0,
        11: 0,
        12: 0,
        13: 0,
        14: 0,
        15: 0,
        16: 0,
        17: 0,
        18: 0,
        19: 0,
        20: 0,
        21: 0,
        22: 0,
        23: 0,
        24: 0,
      },
      urlParams: getUrlParam(),
      isFirst: true,
      showRatioModel: false, // 满桩值列表
      showRatioEdit: false, // 满桩值编辑
      ratioEditData: null, // 编辑满桩值
      ratioErrorModelShow: false, // 满桩值设置的报错弹窗
      ratioErrorRes: [], // 满桩值设置的报错信息
      debounceTimer: null,
      asyncApiTimer: null,
      isFirstMoveMap: true, // 过滤初始化时的 地图中心定位
      mapCenterPosition: null,
      mapCenterTimer: null,
      companyOfIllegalBikes: [],
      companyOfIllegalBikeValue: "",
    };
  },
  computed: {
    ...mapGetters([
      "illegalBikes",
      "tableDataBrands",
      "globaleSelfAreaId",
      "ratioSites",
      "userLevel",
      "user",
      "selfAreaId",
      "authorization",
      "userSelfAreaId",
      "selfAddress",
      "fullPileNum",
      "userSelectAddressData",
    ]),
    aggregation() {
      // 0 - 实体区
      return this.userSelectAddressData
        ? this.userSelectAddressData.aggregation
        : undefined;
    },
    staticData() {
      return staticData;
    },
    staticData2() {
      return staticData2;
    },
    // 统计区展示
    showStatisticsArea() {
      return [1, 2, 3].indexOf(Number(this.userLevel)) > -1;
    },
    // 消息区展示
    showMessageArea() {
      return [2, 3].indexOf(Number(this.userLevel)) > -1;
    },
  },
  created() {
    const vm = this;
    if (vm.user.areaLevel > vm.userLevel) {
      vm.$nextTick(() => {
        vm.$refs.myMap && vm.$refs.myMap.initMap([]);
      });
    } else {
      vm.debounce(vm.initData, vm);
    }
    if (this.$route.query) {
      this.onShowDialog(this.$route.query);
    }
    // vm.getDashboardBike()
    // document.addEventListener('click', (e) => {
    //   console.log(e, vm)
    // })
  },
  methods: {
    companyOfIllegalBikeChange(val) {
      console.log("companyOfIllegalBikeChange", val);
      let bikes = [];
      if (val) {
        bikes = this.illegalBikes.filter((b) => b.brandName === val);
      } else {
        bikes = this.illegalBikes;
      }
      this.$refs.myMap && this.$refs.myMap.initBikeMap(bikes);
    },
    // 获取非法车辆
    getDashboardBike(legality) {
      const vm = this;
      return new Promise((resolve, reject) => {
        const params = {
          selfAreaId: vm.selfAreaId,
          // brandId: '',
          legality,
        };
        Api.dashboardBike(params)
          .then((res) => {
            console.log(res);
            if (res && res.code === 200 && res.data.length) {
              vm.$refs.myMap && vm.$refs.myMap.initBikeMap(res.data);
              const illegalBikes = {
                key: "illegalBikes",
                value: res.data,
              };
              store.commit("user/setUserInfo", illegalBikes);
              const companyOfIllegalBikeObj = {};
              res.data.forEach((bike) => {
                if (companyOfIllegalBikeObj[bike.brandName]) {
                  companyOfIllegalBikeObj[bike.brandName].num++;
                } else {
                  const obj = {
                    name: bike.brandName,
                    num: 1,
                  };
                  companyOfIllegalBikeObj[bike.brandName] = obj;
                }
              });
              vm.companyOfIllegalBikes = [];
              for (const key in companyOfIllegalBikeObj) {
                vm.companyOfIllegalBikes.push(companyOfIllegalBikeObj[key]);
              }
            } else {
              vm.$message.warning(res.message || res.data || "数据为空");
            }
          })
          .catch((err) => {
            console.log("the getDashboardBike has problem: ", err);
          });
      });
    },
    // 初始化
    debounce(method, context, delay) {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(function () {
        method.call(context);
      }, delay || 1500);
    },
    // 满桩值设置
    showWindowPop(site) {
      this.$refs.myMap.showWindowPop(site);
    },
    searchMapFromRatio(search) {
      const params = {
        selfAreaId: this.selfAreaId,
      };
      params.searchType = "5";
      if (search && search.time) {
        params.startTime = new Date(search.time[0]).getTime();
        params.endTime = new Date(search.time[1]).getTime();
      }
      if (search) {
        params.messageType = search.messageType;
      }
      Api.dashboardSearch(params).then((res) => {
        if (res.code === 200) {
          this.currMap = res.data;
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    onRatioEditCancel() {
      this.$confirm("你是否确定放弃本次编辑？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.ratioEdit.onCancel();
          this.showRatioEdit = false;
          this.showRatioModel = true;
          // this.initData()
        })
        .catch(() => {});
    },
    backIndex() {
      this.$router.push({ name: "index", params: { id: this.selfAreaId } });
    },
    onRatioEdit() {
      this.$refs.ratioEdit.onSure();
    },
    changeShow() {
      if (this.$route.query && this.$route.query.type == 3) {
        this.backIndex();
        return;
      }
      this.showRatioModel = false;
      this.initData();
    },
    changeShowRatioEdit(row) {
      this.ratioEditData = row;
      this.searchMapFromRatio();
      this.showRatioModel = false;
      this.showRatioEdit = true;
    },
    bikeTypeChange(val) {
      if (val === 0) {
        // 自行车
        this.brandBikeList = this.siteInfoData.brandBike;
      } else if (val === 1) {
        // 电动车
        this.brandBikeList = this.siteInfoData.brandEBike;
      }
      this.brand = "";
      this.brandId = "";
    },
    brandChange(brandId) {
      console.log(brandId);
      this.brandId = brandId;
      this.handleSiteInfo();
    },
    async onShowBike(item) {
      console.log(1111, item);
      // item 站点信息
      if (item.clickType === 1) {
        // 车辆信息
        this.onShowDialog2({
          ...item,
          type: "bikes",
          bikeType: item.bikeType, // 0-自行车，1-电动车
        });
      } else if (item.clickType === 2) {
        // 车辆总数曲线图
        this.onShowDialog2({
          ...item,
          type: "bikesEcharts",
          bikeType: 0, // 0-自行车，1-电动车
        });
      } else if (item.clickType === 3) {
        // 站点历史详情
        this.onShowDialog({
          ...item,
          type: 4,
          fromAmap: true,
        });
      } else if (item.clickType === 4) {
        // 满桩值修改
        const res = this.$refs.ratioEdit.checkParmas();
        if (res === 3) {
          return null;
        }
        const ruleForm = this.$refs.ratioEdit.ruleForm;
        this.ratioErrorRes = await this.checkMagnifySite(ruleForm, item);
        if (this.ratioErrorRes.length) {
          this.ratioErrorRes.forEach((item) => {
            item.week = this.changeWeeks(item);
          });
          this.ratioErrorModelShow = true;
        } else {
          // 初始化
          const ratioEditData = this.$refs.ratioEdit.ratioEditData;
          const params = {
            taskId:
              ratioEditData && ratioEditData.taskId
                ? ratioEditData.taskId
                : undefined,
            siteId: item.siteId,
            ratio: 1,
            siteName: item.siteName,
          };
          this.$refs.ratioEdit.addTableData(params);
        }
      } else if (item.clickType === 5) {
        // 通过浮窗删除当前站点
        console.log(item);
        this.showConfirm(
          "温馨提示",
          "你是否确定删除“" + item.siteName + "”站点？",
          () => {
            this.handleDelDevice(item);
          },
          () => {}
        );
      }
    },
    showConfirm(textTitle, text, successFn, failFn) {
      this.$confirm(text, textTitle, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          successFn && successFn.call(this);
        })
        .catch(() => {
          failFn && failFn.call(this);
        });
    },
    handleDelDevice(item) {
      const vm = this;
      const params = {
        selfAreaId: this.selfAreaId,
      };
      const data = {
        siteId: item.siteId,
        areaId: item.areaId,
      };
      Api.deleteDeviceSite(data, params).then((res) => {
        if (res.code === 200) {
          vm.$message.success("站点删除成功！");
          vm.refreshAddress();
          vm.changeCurrMap(item);
        } else {
          vm.$message.warning(res.message);
        }
      });
    },
    changeCurrMap(target) {
      let index = -1;
      this.tableData.map.forEach((item, i) => {
        if (item.siteId === target.siteId) {
          index = i;
        }
      });
      if (index !== -1) {
        this.tableData.map.splice(index, 1);
        // this.$refs.myMap && this.$refs.myMap.initMap(this.tableData.map)
        this.$refs.myMap &&
          this.$refs.myMap.delSiteAndShowMap(this.tableData.map);
      }
    },
    refreshAddress() {
      const vm = this;
      const params = {
        selfAreaId: vm.globaleSelfAreaId,
        userAreaId: vm.globaleSelfAreaId,
      };
      // 用户区域范围拉取
      params.areaId = vm.globaleSelfAreaId;
      store
        .dispatch("user/setSideBarLoading", {
          value: true,
        })
        .then(() => {});
      store.dispatch("user/getUserArea2", params).then(() => {
        store
          .dispatch("user/setSideBarLoading", {
            value: false,
          })
          .then(() => {});
      });
    },
    changeWeeks(row) {
      const t = ` ${row.startHour}-${row.endHour}`;
      const ws = row.week.split(",");
      const wsText = [];
      for (let i = 0, len = ws.length; i < len; i++) {
        this.getWeekText(i, ws[i]) && wsText.push(this.getWeekText(i, ws[i]));
      }
      return `${wsText.length ? wsText.join(",") : ""}${t}`;
    },
    getWeekText(week, weekValue) {
      if (weekValue === "1") {
        return {
          0: "星期天",
          1: "星期一",
          2: "星期二",
          3: "星期三",
          4: "星期四",
          5: "星期五",
          6: "星期六",
        }[week];
      }
      return false;
    },
    checkMagnifySite(ruleForm, site) {
      const params = {
        ...ruleForm,
        selfAreaId: this.selfAreaId,
        siteId: site.siteId,
        week: ruleForm.week.join(","),
        alias: undefined,
      };
      return new Promise((resolve, reject) => {
        Api.checkMagnifySite(params)
          .then((res) => {
            if (res.code === 200) {
              resolve(res.data);
            } else {
              reject(res);
            }
          })
          .catch((err) => {
            console.log("the siteReturnStatistics has problom:", err);
            reject(err);
          });
      });
    },
    // jjSearch 精准搜索
    jjSearch(item) {
      if (this.$refs.stationSearch && item.siteId) {
        this.$refs.stationSearch.siteSearch(item.siteId);
      } else if (this.$refs.stationSearch && item.bikeId) {
        this.$refs.stationSearch.search(item.bikeId);
      } else if (this.urlParams.siteName) {
        this.$refs.stationSearch.siteNameSearch(this.urlParams.siteName);
      }
      this.$refs["w-dialog"].onCloseDialog();
    },
    jjSearchFromHistory(item) {
      this.$refs.myMap.jjSearchFromHistory(item);
    },
    pageNoChange2(page) {
      this.formData2.pageNum = page;
      this.handleSiteInfo();
    },
    pageSizeChange2(size) {
      this.formData2.pageSize = size;
      this.handleSiteInfo();
    },
    onExport() {
      alert("onExport");
    },
    siteReturnStatistics(params) {
      const vm = this;
      return new Promise((resolve, reject) => {
        Api.siteReturnStatistics(params)
          .then((res) => {
            if (res.code === 200) {
              vm.siteReturnStatisticsData = res.data;
              vm.companySelect = 99;
              vm.companyOptions=[];
              for (const key in vm.siteReturnStatisticsData) {
                vm.companyOptions.push({
                  value: key,
                  label: key,
                });
              }
              resolve(true);
            } else {
              reject(new Error("the siteReturnStatistics has problom!"));
              vm.$message.warning(res.message);
            }
          })
          .catch((err) => {
            reject(new Error("the siteReturnStatistics has problom!"));
            console.log(err);
          });
      });
    },
    siteRentStatistics(params) {
      const vm = this;
      return new Promise((resolve, reject) => {
        Api.siteRentStatistics(params)
          .then((res) => {
            if (res.code === 200) {
              vm.siteRentStatisticsData = res.data;
              vm.companySelect = 99;
              for (const key in vm.siteRentStatisticsData) {
                vm.companyRentOptions.push({
                  value: key,
                  label: key,
                });
              }
              resolve(true);
            } else {
              reject(new Error("the siteRentStatistics has problom!"));
              vm.$message.warning(res.message);
            }
          })
          .catch((err) => {
            reject(new Error("the siteRentStatistics has problom!"));
            console.log(err);
          });
      });
    },
    async handleBikesEcharts() {
      const vm = this;
      const params = {
        selfAreaId: vm.selfAreaId,
        siteId: vm.siteInfoData.siteId,
        date: vm.getToday(vm.bikesEchartsData),
      };
      await vm.siteReturnStatistics(params);
      await vm.siteRentStatistics(params);
      vm.translate(vm.companySelect);
      vm.$refs["w-dialog2"].onShowDialog();
      // Api.siteReturnStatistics(params)
      //   .then(res => {
      //     if (res.code === 200) {
      //       vm.siteReturnStatisticsData = res.data
      //       vm.companySelect = 99
      //       for (const key in vm.siteReturnStatisticsData) {
      //         vm.companyOptions.push({
      //           value: key,
      //           label: key
      //         })
      //       }
      //       vm.translate(vm.companySelect)
      //       vm.$refs['w-dialog2'].onShowDialog()
      //     } else {
      //       vm.$message.warning(res.message)
      //     }
      //   })
      //   .catch(err => {
      //     console.log(err)
      //   })
      // Api.siteRentStatistics()
      //   .then(res => {
      //     console.log(res)
      //   })
      //   .catch(err => {
      //     console.log(err)
      //   })
    },
    companySelectChange(val) {
      this.translate(val);
    },
    translate(companySelect) {
      const vm = this;
      const avgTime = [];
      const avgPower = [];
      const avgTimeRent = [];
      const avgPowerRent = [];
      vm.hourAndPower = {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 0,
        9: 0,
        10: 0,
        11: 0,
        12: 0,
        13: 0,
        14: 0,
        15: 0,
        16: 0,
        17: 0,
        18: 0,
        19: 0,
        20: 0,
        21: 0,
        22: 0,
        23: 0,
        24: 0,
      };
      vm.hourAndPowerRent = {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 0,
        9: 0,
        10: 0,
        11: 0,
        12: 0,
        13: 0,
        14: 0,
        15: 0,
        16: 0,
        17: 0,
        18: 0,
        19: 0,
        20: 0,
        21: 0,
        22: 0,
        23: 0,
        24: 0,
      };
      if (companySelect === 99) {
        for (const d in vm.siteReturnStatisticsData) {
          vm.siteReturnStatisticsData[d].forEach((item) => {
            vm.hourAndPower[item.hour] = vm.hourAndPower[item.hour] + item.num;
          });
        }
        for (const d in vm.siteRentStatisticsData) {
          vm.siteRentStatisticsData[d].forEach((item) => {
            vm.hourAndPowerRent[item.hour] =
              vm.hourAndPowerRent[item.hour] + item.num;
          });
        }
      } else {
        vm.siteReturnStatisticsData[companySelect].forEach((item) => {
          vm.hourAndPower[item.hour] = vm.hourAndPower[item.hour] + item.num;
        });
        vm.siteRentStatisticsData[companySelect].forEach((item) => {
          vm.hourAndPowerRent[item.hour] =
            vm.hourAndPowerRent[item.hour] + item.num;
        });
      }
      // console.log(111, vm.hourAndPower)
      for (const key in vm.hourAndPower) {
        avgTime.push(key);
        avgPower.push(vm.hourAndPower[key]);
      }
      for (const key in vm.hourAndPowerRent) {
        avgTimeRent.push(key);
        avgPowerRent.push(vm.hourAndPowerRent[key]);
      }
      const copyAvgPower = JSON.parse(JSON.stringify(avgPower)).sort(
        (a, b) => a - b
      );
      const copyAvgPowerRent = JSON.parse(JSON.stringify(avgPowerRent)).sort(
        (a, b) => a - b
      );
      const maxReturn = copyAvgPower[copyAvgPower.length - 1];
      const maxRent = copyAvgPowerRent[copyAvgPowerRent.length - 1];
      const maxData = {};
      let max = 0;
      if (maxReturn > maxRent) {
        max = maxReturn;
      } else if (maxReturn < maxRent) {
        max = maxRent;
      } else {
        max = maxReturn;
      }
      if (max <= 4) {
        maxData.max = 4;
        maxData.splitNumber = 4;
      } else if (max > 4 && max <= 8) {
        maxData.max = 8;
        maxData.splitNumber = 4;
      } else if (max > 8 && max <= 16) {
        maxData.max = 16;
        maxData.splitNumber = 4;
      } else if (max > 16 && max <= 30) {
        maxData.max = 30;
        maxData.splitNumber = 6;
      } else if (max > 30 && max <= 50) {
        maxData.max = 50;
        maxData.splitNumber = 5;
      } else if (max > 50) {
        maxData.max = max;
        maxData.splitNumber = 5;
      }
      const options = vm.getDrawLineParams(
        avgTime,
        avgPower,
        maxData,
        avgPowerRent
      );
      console.log("options", options);
      vm.$nextTick(() => {
        setTimeout(() => {
          vm.drawLine("echarts", options);
        }, 300);
      });
    },
    // avgPower 还车
    getDrawLineParams(avgTime, avgPower, maxData, avgPowerRent) {
      const options = {
        legend: {
          selectedMode: false,
          data: ["还车数", "租车数"],
        },
        // x抽
        xAxis: {
          type: "category",
          // boundaryGap: false,
          data: avgTime, // this.getEveryDateStr(this.getWeekBefore(), this.getToday()),
          name: "时间", // x轴名称
          // x轴名称样式
          nameTextStyle: {
            fontWeight: 600,
            fontSize: 26,
          },
          axisTick: { show: false },
        },
        // y轴
        yAxis: {
          type: "value",
          name: "车辆数", // y轴名称
          scale: true,
          max: maxData.max,
          min: 0,
          splitNumber: maxData.splitNumber,
          boundaryGap: [0.2, 0.2],
          // y轴名称样式
          nameTextStyle: {
            fontWeight: 600,
            fontSize: 26,
            // color: '#D6D6D6'
          },
          splitLine: {
            // 网格线
            lineStyle: {
              type: "dashed", // 设置网格线类型 dotted：虚线   solid:实线
            },
            show: true, // 隐藏或显示
          },
        },
        series: [
          {
            name: "还车数",
            type: "bar",
            data: avgPower, // ['3', '2', '4', '4', '5', '100', '500'],
            color: "#1F8FFB",
          },
          {
            name: "租车数",
            type: "bar",
            data: avgPowerRent, // ['3', '2', '4', '4', '5', '100', '500'],
            color: "#F6AD32",
          },
        ],
      };
      return options;
    },
    drawLine(id, options) {
      this.charts = echarts.init(document.getElementById(id));
      this.charts.setOption({
        ...options,
        tooltip: {
          trigger: "axis", // 触发类型，默认数据触发，见下图，可选为：'item' ¦ 'axis'
          showDelay: 20, // 显示延迟，添加显示延迟可以避免频繁切换，单位ms
          hideDelay: 100, // 隐藏延迟，单位ms
          transitionDuration: 0.4, // 动画变换时间，单位s
          backgroundColor: "rgba(0,0,0,0.7)", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "#333", // 提示边框颜色
          borderRadius: 4, // 提示边框圆角，单位px，默认为4
          borderWidth: 0, // 提示边框线宽，单位px，默认为0（无边框）
          padding: 5, // 提示内边距，单位px，默认各方向内边距为5，
          // 接受数组分别设定上右下左边距，同css
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
            lineStyle: {
              // 直线指示器样式设置
              color: "#48b",
              width: 2,
              type: "solid",
            },
            shadowStyle: {
              // 阴影指示器样式设置
              width: "auto", // 阴影大小
              color: "rgba(150,150,150,0.3)", // 阴影颜色
            },
          },
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "5%",
          right: "10%",
          bottom: "2%",
          containLabel: true,
        },

        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
      });
      this.charts.on("click", function (data) {
        console.log(111, data);
      });
      const vm = this;
      window.addEventListener("resize", function () {
        vm.charts.resize();
      });
    },
    getToday(date) {
      // 返回 '2020-08-14'
      const day2 = date ? new Date(date) : new Date();
      day2.setTime(day2.getTime());
      return (
        day2.getFullYear() +
        "-" +
        (day2.getMonth() < 9
          ? "0" + (day2.getMonth() + 1)
          : day2.getMonth() + 1) +
        "-" +
        (day2.getDate() < 10 ? "0" + day2.getDate() : day2.getDate())
      );
    },
    handleSiteInfo() {
      const vm = this;
      vm.needPagination2 = true;
      // vm.dialogTitle2 = vm.siteInfoData.siteName

      if (vm.siteInfoData.brandId) {
        // 从消息区 查看 过来的
        const params = {
          selfAreaId: vm.selfAreaId,
          brandId: vm.siteInfoData.brandId,
          siteId: vm.siteInfoData.siteId,
          bikeType: vm.siteInfoData.bikeType,
          currentPage: vm.formData2.pageNum,
          pageSize: vm.formData2.pageSize,
        };
        Api.getBrandSiteBike(params).then((res) => {
          if (res.code === 200) {
            vm.tableData2 = res.data.lists;
            vm.total2 = res.data.total;
            vm.subType = vm.siteInfoData.type;
            vm.$refs["w-dialog2"].onShowDialog();
          } else {
            this.$message.warning(res.message);
          }
        });
      } else {
        // 从地图弹窗 电瓶车或者自行车 过来的
        console.log("// 从地图弹窗 电瓶车或者自行车 过来的");
        const params = {
          selfAreaId: vm.selfAreaId,
          bikeType: vm.siteInfoData.bikeType,
          siteId: vm.siteInfoData.siteId,
          currentPage: vm.formData2.pageNum,
          pageSize: vm.formData2.pageSize,
        };
        Api.siteBike(params).then((res) => {
          if (res.code === 200) {
            vm.tableData2 = res.data.lists;
            vm.total2 = res.data.total;
            vm.subType = vm.siteInfoData.type;
            vm.$refs["w-dialog2"].onShowDialog();
          } else {
            this.$message.warning(res.message);
          }
        });
      }
    },
    onShowDialog2(type) {
      const vm = this;
      if (type === "brandOperationNum") {
        // 运维人数
        vm.dialogTitle2 = "运维人员信息";
        vm.paramsType = "maintain_person";
        if (this.detail.maintainPersonUrl) {
          downloadExcel(this.detail.maintainPersonUrl);
        } else {
          this.$message.warning("运维人员信息不存在！");
        }
        return false;
      } else if (type === "brandBikeNum") {
        // 核定自行车数
        vm.dialogTitle2 = "自行车信息";
        vm.paramsType = "bicycle_excel";
        if (this.detail && this.detail.bicycleUrl) {
          downloadExcel(this.detail.bicycleUrl);
        } else {
          this.$message.warning("自行车信息不存在！");
        }
        return false;
      } else if (type === "brandEBikeNum") {
        // 核定电动车数
        vm.dialogTitle2 = "电动车信息";
        vm.paramsType = "electric_vehicle_excel";
        if (this.detail.electricVehicleUrl) {
          downloadExcel(this.detail.electricVehicleUrl);
        } else {
          this.$message.warning("电动车信息不存在！");
        }
        return false;
      } else if (type && type.type === "bikes") {
        // 当前站点的车辆
        vm.siteInfoData = type;
        vm.subType = type.type;
        vm.dialogTitle2 =
          vm.siteInfoData && vm.siteInfoData.bikeType === 0
            ? "自行车车辆信息"
            : vm.siteInfoData && vm.siteInfoData.bikeType === 1
            ? "电动车车辆信息"
            : "车辆信息";
        vm.handleSiteInfo();
        return false;
      } else if (type && type.type === "bikesEcharts") {
        // 还车曲线图
        vm.siteInfoData = type;
        vm.subType = type.type;
        vm.dialogTitle2 = "租还柱状图";
        vm.handleBikesEcharts();
        return false;
      }
      vm.subType = type;
      const params = {
        selfAreaId: vm.selfAreaId,
        brandId: vm.detail.brandId,
        type: vm.paramsType,
      };
      Api.getEnterpriseInfoById(params).then((res) => {
        if (res.code === 200) {
          vm.tableData2 = res.data;
          vm.$refs["w-dialog2"].onShowDialog();
        } else {
          this.$message.warning(res.message);
        }
      });
      this.$refs["w-dialog2"].onShowDialog();
    },
    handleClose2() {
      this.needPagination2 = false;
      this.siteInfoData = null;
      this.brandBikeList = [];
      this.companyOptions = [];
      this.tableData2 = [];
      this.bikeType = "";
      this.brand = "";
      this.brandId = "";
      this.bikesEchartsData = new Date();
      this.formData2.pageNum = 1;
      this.formData2.pageSize = 10;
      this.$refs["w-dialog2"].onCloseDialog();
    },
    async onShowDialog(data) {
      console.log(data);
      this.detailSimple = data;
      if (data.type === 3) {
        store.commit("globalVariable/save", {
          key: "ratioSites",
          value: [],
        });
        // 消息区 - 满桩值设置
        if (data.from === "ratioEdit") {
          this.showRatioEdit = false;
        }
        this.showRatioModel = true;
        return;
      }
      switch (data.type) {
        case 1: // 统计区 - 企业
          this.dialogTitle = "企业信息";
          this.currentComponent = "text-list";
          await this.getCompanyData();
          await this.getDashboardInfo();
          this.getAddress();
          break;
        case 2: // 统计区 - 查看
          this.dialogTitle = data ? data.brandName + "站点车辆分布" : "";
          this.currentComponent = "table-list";
          this.typeName = "site";
          break;
        case 3: // 消息区 - 历史记录
          this.dialogTitle = "今日历史消息";
          this.currentComponent = "history-list";
          this.typeName = "history";
          break;
        case 4: // 消息区 - 详情
          this.dialogTitle = data ? data.siteName + "站点消息详情" : "";
          this.currentComponent = "message-list";
          this.typeName = "message";
          break;
      }
      this.$refs["w-dialog"].onShowDialog();
    },
    getDashboardInfo() {
      const vm = this;
      return new Promise((resolve, reject) => {
        const params = {
          selfAreaId: vm.selfAreaId,
          brandId: vm.detailSimple.brandId,
        };
        Api.getDashboardInfo(params).then((res) => {
          if (res.code === 200) {
            vm.detail = res.data;
          } else {
            vm.$message.warning(res.message);
          }
          resolve();
        });
      });
    },
    getCompanyData() {
      const vm = this;
      return new Promise((resolve, reject) => {
        const params = {
          selfAreaId: vm.selfAreaId,
        };
        Api.getEnterpriseList(params).then((res) => {
          if (res.code === 200) {
            vm.companyData = res.data.lists;
          } else {
            vm.$message.warning(res.message);
          }
          resolve();
        });
      });
    },
    handleClose() {
      this.detail = {};
      this.dialogTitle = "";
      this.currentComponent = "";
      this.$refs["w-dialog"].onCloseDialog();
    },
    onSure() {
      this.handleClose();
    },
    onSearch(data) {
      // 010579010129
      this.currMap = data;
    },
    initData() {
      const vm = this;
      // 3分钟更新地图
      vm.setPollingMap();
      setTimeout(() => {
        // 10秒钟更新消息
        vm.polling();
        // 异步 页面初始化参数
        vm.asyncApiDebounce(vm.asyncApi, vm); // asyncApiTimer
      }, 0);
    },
    asyncApiDebounce(method, context, delay) {
      if (this.asyncApiTimer) {
        clearTimeout(this.asyncApiTimer);
      }
      this.asyncApiTimer = setTimeout(function () {
        method.call(context);
      }, delay || 1500);
    },
    asyncApi(item) {
      const vm = this;
      const params = {
        selfAreaId: vm.selfAreaId,
      };
      store.dispatch("user/getFullPileNum", params);
      vm.getMsgCounts();
    },
    getMsgCounts() {
      if (this.userLevel >= 2) {
        const vm = this;
        const params = {
          selfAreaId: vm.selfAreaId,
        };
        Api.getMsgCounts(params).then((res) => {
          if (res.code === 200) {
            vm.siteMessageLength = res.data;
            const userSiteMessageLength = {
              key: "siteMessageLength",
              value: vm.siteMessageLength,
            };
            store.commit("user/setUserInfo", userSiteMessageLength);
          } else {
            vm.$message.warning(res.message);
          }
        });
      } else {
        const userSiteMessageLength = {
          key: "siteMessageLength",
          value: 0,
        };
        store.commit("user/setUserInfo", userSiteMessageLength);
      }
    },
    transitionTo(arr) {
      const res = [];
      var textStyle = {
        fontSize: 12,
        fontWeight: "normal",
        fillColor: "red",
        padding: "2, 5",
      };
      if (arr.length) {
        arr.forEach((mark, index) => {
          if (mark.siteLon && mark.siteLat && mark.siteName && mark.siteId) {
            // const obj = {
            //     // lnglat: [mark.siteLon, mark.siteLat],
            //     siteLon: mark.siteLon,
            //     siteLat: mark.siteLat,
            //
            //     name: mark.siteName,
            //     id: mark.siteId,
            //     status: this.getSiteStatus(mark.currentNum, mark.siteBikeCeiling),
            //     siteId: mark.siteId,
            //     createTime: mark.createTime,
            //     currentNum: mark.currentNum,
            //     siteCeiling: mark.siteCeiling
            // }
            var obj = {
              name: mark.siteName,
              // icon,
              position: [mark.siteLon, mark.siteLat],
              zIndex: 200,
              text: {
                content: mark.siteCeiling,
                direction: "center",
                style: textStyle,
              },
            };
            obj.style = this.getSiteStatus(
              mark.currentNum,
              mark.siteBikeCeiling
            ).style;
            res.push(obj);
          }
        });
        return res;
      } else {
        return arr;
      }
    },
    getSiteStatus(curr, total) {
      const obj = {
        style: "",
        status: "",
      };
      if (curr === 0) {
        obj.style = 0; // 空桩  蓝色icon
        obj.status = "空桩";
      } else if (curr / total < 0.2) {
        obj.style = 1; // 偏少  绿色icon
        obj.status = "偏少";
      } else if (curr === total) {
        obj.style = 2; // 满桩  红色icon
        obj.status = "满桩";
      } else if (curr / total > 0.8) {
        obj.style = 3; // 偏多  黄色icon
        obj.status = "偏多";
      } else {
        obj.style = 4; // 正常
        obj.status = "正常";
      }
      return obj;
    },
    // 移动地图 请求数据 刷新页面
    chearMapCenterTimer() {
      if (this.mapCenterTimer) {
        clearTimeout(this.mapCenterTimer);
      }
    },
    refreshMap(position) {
      const vm = this;
      if (position && !this.isFirstMoveMap) {
        const { lng: lon, lat } = position;
        const distance = 1000;
        // console.log('refreshMap', position, lon, lat, distance, vm.isFirstMoveMap)
        vm.mapCenterPosition = {
          lon,
          lat,
          distance,
        };
        if (vm.mapTimer) {
          clearTimeout(vm.mapTimer);
          vm.mapTimer = null;
        }
        vm.mapCenterDebounce(vm.pollingMap, vm, 1500, true);
        // vm.mapCenterDebounce(() => (console.log('watson')), vm, 2000, true)
      } else {
        vm.isFirstMoveMap = false;
      }
    },
    mapCenterDebounce(method, context, delay, params) {
      if (this.mapCenterTimer) {
        clearTimeout(this.mapCenterTimer);
      }
      this.mapCenterTimer = setTimeout(function () {
        method.call(context, params);
      }, delay || 1500);
    },
    pollingMap(isMovedMap) {
      const vm = this;
      if (location.hash.indexOf(vm.selfAreaId) === -1) {
        clearTimeout(vm.mapTimer);
        return null;
      }
      vm.tableLoading = true;
      let params = {
        selfAreaId: vm.selfAreaId,
      };
      if (isMovedMap && !vm.isFirstMoveMap && vm.mapCenterPosition) {
        params = Object.assign(params, vm.mapCenterPosition);
      }
      Api.dashboard(params)
        .then((res) => {
          if (res.code === 200) {
            vm.tableData = res.data;
            if (res.data && res.data.map) {
              vm.$refs.myMap &&
                vm.$refs.myMap.initMap(res.data.map, null, null, isMovedMap);
            } else {
              vm.$refs.myMap &&
                vm.$refs.myMap.initMap([], null, null, isMovedMap);
            }
            if (vm.urlParams.siteId) {
              vm.isFirst = false;
              setTimeout(() => {
                vm.jjSearch({ siteId: vm.urlParams.siteId });
              }, 300);
            }
            if (!isMovedMap) {
              if (res.data && res.data.statistical) {
                vm.statistical = res.data.statistical;
                vm.statistical.bike =
                  vm.statistical.bike && vm.statistical.bike.length > 10
                    ? res.data.statistical.bike.slice(0, 10)
                    : vm.statistical.bike;
                vm.statistical.ebike =
                  vm.statistical.ebike && vm.statistical.ebike.length > 10
                    ? res.data.statistical.ebike.slice(0, 10)
                    : vm.statistical.ebike;

                vm.statistical.eSiteNumTotal =
                  res.data.statistical.ebike.reduce(
                    (total, item) => total + item.siteNum,
                    0
                  );
                vm.statistical.bSiteNumTotal = res.data.statistical.bike.reduce(
                  (total, item) => total + item.siteNum,
                  0
                );
              }

              vm.siteMessage =
                res.data.siteMessage && res.data.siteMessage.length > 5
                  ? res.data.siteMessage.slice(0, 5)
                  : res.data.siteMessage;

              vm.mapTimer = setTimeout(vm.setPollingMap, 1000 * 60 * 3);
            }
          } else {
            vm.$message.warning(res.message);
            vm.$refs.myMap && vm.$refs.myMap.initMap([]);
          }
          vm.tableLoading = false;
        })
        .catch((err) => {
          vm.tableLoading = false;
          console.log(err);
        });
    },
    initMessage() {
      const vm = this;
      const params = {
        selfAreaId: this.selfAreaId,
      };
      if (location.hash.indexOf(vm.selfAreaId) === -1) {
        // console.log('this.selfAreaId', this.selfAreaId, location.hash, this.timer)
        clearTimeout(vm.timer);
        return null;
      }
      Api.dashboardGet(params)
        .then((res) => {
          if (res.code === 200) {
            if (res.data && res.data.statistical) {
              vm.statistical = res.data.statistical;
              vm.statistical.bike =
                vm.statistical.bike && vm.statistical.bike.length > 10
                  ? res.data.statistical.bike.slice(0, 10)
                  : vm.statistical.bike;
              vm.statistical.ebike =
                vm.statistical.ebike && vm.statistical.ebike.length > 10
                  ? res.data.statistical.ebike.slice(0, 10)
                  : vm.statistical.ebike;

              vm.statistical.eSiteNumTotal = res.data.statistical.ebike.reduce(
                (total, item) => total + item.siteNum,
                0
              );
              vm.statistical.bSiteNumTotal = res.data.statistical.bike.reduce(
                (total, item) => total + item.siteNum,
                0
              );
            }
            vm.siteMessage =
              res.data.siteMessage && res.data.siteMessage.length > 5
                ? res.data.siteMessage.slice(0, 5)
                : res.data.siteMessage;
            store.commit("globalVariable/save", {
              key: "siteMessage",
              value: res.data.siteMessage,
            });
            vm.timer = setTimeout(vm.polling, 10000);
          } else {
            vm.$message.warning(res.message);
          }
        })
        .catch((err) => console.log(err));
    },
    setPollingMap() {
      const vm = this;
      vm.pollingMap();
    },
    polling() {
      const vm = this;
      vm.initMessage();
    },
    pageNoChange() {
      console.log("pageNoChange");
    },
    getAddress() {
      const vm = this;
      if (vm.detail && vm.detail.areaId) {
        // 归属区域
        const params = {
          areaId: vm.detail.areaId,
          selfAreaId: vm.selfAreaId,
        };
        Api.getUserArea(params).then((res) => {
          if (res.code === 200) {
            vm.$set(vm.detail, "areaIdText", "");
            if (res.data.province && res.data.province.areaName) {
              vm.detail.areaIdText += res.data.province.areaName;
            }
            if (res.data.city && res.data.city.areaName) {
              vm.detail.areaIdText += res.data.city.areaName;
            }
            if (res.data.region && res.data.region.areaName) {
              vm.detail.areaIdText += res.data.region.areaName;
            }
          }
        });
      }
      if (vm.detail && vm.detail.operationAreaId) {
        // 运营范围
        const params = {
          areaId: vm.detail.operationAreaId,
          selfAreaId: vm.selfAreaId,
        };
        Api.getUserArea(params).then((res) => {
          if (res.code === 200) {
            vm.$set(vm.detail, "operationAreaIdText", "");
            if (res.data.province && res.data.province.areaName) {
              vm.detail.operationAreaIdText += res.data.province.areaName;
            }
            if (res.data.city && res.data.city.areaName) {
              vm.detail.operationAreaIdText += res.data.city.areaName;
            }
            if (res.data.region && res.data.region.areaName) {
              vm.detail.operationAreaIdText += res.data.region.areaName;
            }
          }
        });
      }
      if (vm.detail && vm.detail.launchArea) {
        // 投放范围
        const params = {
          areaId: vm.detail.launchArea,
          selfAreaId: vm.selfAreaId,
        };
        Api.getUserArea(params).then((res) => {
          if (res.code === 200) {
            vm.$set(vm.detail, "launchAreaText", "");
            if (res.data.province && res.data.province.areaName) {
              vm.detail.launchAreaText += res.data.province.areaName;
            }
            if (res.data.city && res.data.city.areaName) {
              vm.detail.launchAreaText += res.data.city.areaName;
            }
            if (res.data.region && res.data.region.areaName) {
              vm.detail.launchAreaText += res.data.region.areaName;
            }
          }
        });
      }
    },
    clearMapTimer() {
      const vm = this;
      if (vm.mapTimer) {
        // console.log('----------清除地图刷新成功！----------')
        clearTimeout(vm.mapTimer);
        vm.mapTimer = null;
      }
    },
  },
  beforeDestroy() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    if (this.asyncApiTimer) {
      clearTimeout(this.asyncApiTimer);
    }
    // console.log('DailyDuty-beforeDestroy', this.timer, this.mapTimer)
    clearTimeout(this.timer);
    this.timer = null;
    clearTimeout(this.mapTimer);
    this.mapTimer = null;
  },
};
</script>

<style lang="less" scoped>
.dialiyDuty.layout {
  width: 100%;
}

.dialiyDuty {
  .station-search {
    position: absolute;
    top: 16px;
    left: 16px;
  }
  .bike-company {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 1;
  }

  .message-wall {
    display: flex;
    padding: 0 8px;
    width: 100%;
    justify-content: space-between;
    position: absolute;
    align-items: flex-end;
    bottom: 8px;
    left: 0;
    z-index: 202;
    box-sizing: border-box;
  }
  .ratio-btns {
    padding: 8px 0;
    background: #fafafa;
    text-align: center;
    position: fixed;
    bottom: 0;
    width: calc(100% - 180px);
  }
}

.bikesEcharts-header {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.45);

  span {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #000;
  }

  .mr40 {
    margin-right: 40px;
  }
}

.el-select-dropdown__item {
  padding-left: 12px;
}

.dialiyDuty-dialog-content {
  #echarts {
    width: 780px;
    height: 400px;
  }
}

.message-wall.w50p {
  width: 50%;
}
.ratio-error-text {
  font-size: 14px;
  color: #e6352c;
  line-height: 1;
  margin-bottom: 15px;
}
.sp-red {
  color: #ff5000;
}
</style>
